import React, { useState } from "react";
import {
  Chip,
  Box,
  Paper,
  Typography,
  Container,
  FormControl,
  OutlinedInput,
  InputLabel,
  Select,
  MenuItem,
  Button,
  FormGroup,
  Checkbox,
  ListItemText,
  ListSubheader,
  Divider,
} from "@mui/material";
import HeroImg from "../../assets/images/hero-img.png";
import HeroImgMobile from "../../assets/images/hero_mobile_img.png";
import MenuComponent from "../common/Menu/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import SearchField from "../common/SearchField/SearchField";
import CheckIcon from "@mui/icons-material/Check";
import Btn from "../common/Button/Button";
import CheckMarkSelect from "../common/CheckMarkSelect/CheckMarkSelect";
import Field from "../common/Field/Fi";
import useMediaQuery from "@mui/material/useMediaQuery";
import SearchHomeModal from "../common/Modal/SearchHomeModal";
import YearSelect from "../common/YearSelect/YearSelect";
import MakeModel from "../common/CheckMarkSelect/MakeModel";

function Hero() {
  const mobileMatch = useMediaQuery("(max-width:600px)");
  const [tabValue, setTabValue] = useState(0);
  const [moreOptions, setMoreOptions] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [yearDisabled, setYearDisabled] = useState(true);
  const years = ["2000", "2001", "2002", "2003", "2004", "2005"];

  const categorySelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setDataList(typeof value === "string" ? value.split(",") : value);
  };

  const modelSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setModelList(
      // On autofill we get a the stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleChange = (_, newValue) => {
    setTabValue(newValue);
  };
  const [mock, setMock] = React.useState("");
  const handleMockChange = (event) => {
    setMock(event.target.value);
  };

  const [searchModal, setSearchModal] = React.useState(false);

  const toggleSearchModal = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setSearchModal(open);
  };

  return (
    <Paper
      square={true}
      sx={{
        display: "flex",
        filter: {
          xs: "drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.14)) drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.12)) drop-shadow(0px 1px 0px rgba(0, 0, 0, 0.2))",
          sm: "none",
        },
        boxShadow: "none",
        backgroundImage: {
          xs: `url(${HeroImgMobile})`,
          sm: `url(${HeroImg})`,
        },
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition:"center center",
        minHeight: { xs: "280px", sm: "600px" },
        flexFlow: "column",
        padding: { xs: "0 24px 50px", sm: "0px" },
        alignItems: { xs: "start", sm: "center" },
        justifyContent: { xs: "end", sm: "center" },
        borderRadius: { xs: "0px 0px 8px 8px;", sm: "0px" },
        marginBottom: { xs: "16px", sm: "0px" },
        backgroundAttachment: "initial",
        backgroundColor: "transparent",
      }}
    >
      <Typography
        variant={mobileMatch ? "h3" : "h1"}
        sx={{
          marginBottom: { xs: "24px", sm: "48px" },
          fontWeight: { xs: "600", sm: "700" },
          fontSize: { xs: "22px", sm: "32px", md: "48px" },
          lineHeight: { xs: "26px" },
          width: { xs: "250px", sm: "auto" },
          color: "white",
          textShadow:
            "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2)",
        }}
      >
        Discover the machinery you'll love
      </Typography>
      {mobileMatch ? (
        <Field
          disabled={true}
          labelStyle={{
            fontSize: "16px !important",
            lineHeight: "24px !important",
          }}
          value={mock}
          handleChange={handleMockChange}
          label="Search Machinery"
          startIcon={
            <SearchIcon
              sx={{
                width: "24px",
                height: "24px",
                color: "#808080",
              }}
            />
          }
          onClick={toggleSearchModal(true)}
          height="48px"
          labelColor="text.primary"
          transform="translate(40px,12px)"
          sx={{
            borderRadius: "8px",
            width: "100%",
            height: "48px",
            border: "none",
            backgroundColor: "#fff",
            boxShadow:
              "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          }}
        />
      ) : (
        <Box
          sx={{
            borderRadius: "8px",
            backgroundColor: "white",
            width: { xs: "93.75%", md: "896px" },
            padding: "24px 25px",
            boxShadow:
              "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Container
            sx={{ display: "flex", columnGap: "8px", marginBottom: "16.86px" }}
            disableGutters={true}
          >
            <Btn
              variant="outlined"
              onClick={(e) => handleChange(e, 0)}
              bgColor={tabValue === 0 ? "#255CCE1A" : "#F5F5F5"}
              outColor={tabValue === 0 ? "#255CCE" : "#FFF"}
              sx={{
                maxWidth: "58px",
                minWidth: "58px",
                height: "36px",
                padding: "6px 16px",
              }}
              size="lg"
              txColor={tabValue === 0 ? "#255CCE" : "text.primary"}
              typoVariant="body1"
              fontWeight="400"
            >
              Pro
            </Btn>
            <Btn
              variant="outlined"
              onClick={(e) => handleChange(e, 1)}
              bgColor={tabValue === 1 ? "#255CCE1A" : "#F5F5F5"}
              outColor={tabValue === 1 ? "#255CCE" : "#FFF"}
              sx={{
                maxWidth: "61px",
                minWidth: "61px",
                height: "36px",
                padding: "6px 16px",
              }}
              size="lg"
              txColor={tabValue === 1 ? "#255CCE" : "text.primary"}
              typoVariant="body1"
              fontWeight="400"
            >
              Buy
            </Btn>
            <Btn
              variant="outlined"
              onClick={(e) => handleChange(e, 2)}
              bgColor={tabValue === 2 ? "#255CCE1A" : "#F5F5F5"}
              outColor={tabValue === 2 ? "#255CCE" : "#FFF"}
              sx={{
                maxWidth: "90px",
                minWidth: "90px",
                height: "36px",
                padding: "6px 16px",
              }}
              size="lg"
              txColor={tabValue === 2 ? "#255CCE" : "text.primary"}
              typoVariant="body1"
              fontWeight="400"
            >
              Auction
            </Btn>
          </Container>
          <Box
            sx={{
              display: tabValue === 0 ? "block" : "none",
              maxHeight: moreOptions ? "253px" : "189px",
            }}
          >
            <Container
              sx={{ display: "flex", columnGap: "17px", alignItems: "center" }}
              disableGutters={true}
            >
              <SearchField label="Category, Make or Model" />
              <Btn
                variant="contained"
                bgColor="#F9D548"
                txColor="text.primary"
                size="lg"
                sx={{ height: "48px", width: "128px", boxShadow: "none" }}
                hoverBg="#F3C04F"
              >
                Search
              </Btn>
            </Container>
            <Container
              sx={{
                display: { xs: "none", sm: "flex" },
                marginTop: "17.71px",
                columnGap: "17px",
                flexWrap: { xs: "wrap", sm: "nowrap" },
                rowGap: { xs: "24px", sm: "0px" },
                alignItems: "center",
                visibility: !moreOptions && "hidden",
                position: !moreOptions && "absolute",
                left: !moreOptions && "0",
              }}
              disableGutters={true}
            >
              <Container
                disableGutters={true}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "18px",
                  width: "fit-content",
                }}
              >
                <CheckMarkSelect
                  handleChange={categorySelectChange}
                  dataList={dataList}
                  label="Category"
                  menuWidth={336}
                  formStyle={{
                    backgroundColor: dataList.length > 0 && "#255CCE1A",
                  }}
                  sx={{ width: { sm: "179px", md: "270px" } }}
                >
                  <MenuItem
                    disableRipple
                    sx={{ paddingBottom: "0px !important" }}
                  >
                    <Field
                      label="Category"
                      labelVariant="body2"
                      labelFont="14px"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          padding: "0px",
                        },
                        width: { sm: "100%", md: "100%" },
                        height: "38.14px",
                      }}
                      endIcon={
                        <SearchIcon
                          sx={{ color: "#808080", marginRight: "8px" }}
                        />
                      }
                      borderColor="#BFBFBF"
                      labelStyle={{ color: "#616161" }}
                      labelColor="#616161"
                      // value={val}
                      // handleChange={({ target }) => setVal(target.value)}
                      transform="translate(7px,7px)"
                    ></Field>
                  </MenuItem>
                  <ListSubheader>Category 1</ListSubheader>
                  {[
                    "All",
                    "Caterpillar Inc. (203)",
                    "Cat-bt007 (21)",
                    "Doosan (132)",
                    "Hitachi (22)",
                    "JCB (12)",
                  ].map((data, index) => (
                    <MenuItem
                      sx={{ paddingY: "4px !important" }}
                      disableRipple
                      key={index}
                      value={data}
                    >
                      <Checkbox
                        sx={{
                          padding: "0px",
                          marginRight: "4px",
                          "& .MuiSvgIcon-root": { fontSize: 16 },
                          // color: "#6200EE",
                          "&.Mui-checked": {
                            color: "#6200EE",
                          },
                        }}
                        checked={dataList.indexOf(data) > -1}
                      />
                      <ListItemText
                        sx={{
                          fontSize: "16px",
                          lineHeight: "24px",
                          color:
                            dataList.indexOf(data) > -1 ? "#6200EE" : "black",
                        }}
                        primary={data}
                      />
                    </MenuItem>
                  ))}
                  <Divider sx={{ margin: "0px !important" }} />
                  {/* <MenuItem> */}
                  <Container
                    disableGutters={true}
                    sx={{
                      display: "flex",
                      padding: "15px 16px",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "8px",
                      }}
                    >
                      <CheckIcon
                        sx={{
                          width: "16px",
                          height: "16px",
                          color: "#616161",
                        }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "14px",
                          lineHeight: "20px",
                          color: "#616161",
                        }}
                      >
                        {dataList.length} Selected
                      </Typography>
                    </Box>
                    <Button
                      sx={{ padding: "0px", minWidth: "fit-content" }}
                      variant="text"
                      centerRipple={false}
                      onClick={() => {
                        console.log("working");
                        setDataList([]);
                      }}
                    >
                      Reset
                    </Button>
                  </Container>
                  {/* </MenuItem> */}
                </CheckMarkSelect>
                <MakeModel
                setYearDisabled={setYearDisabled}
                  disabled={dataList.length > 0 ? false : true}
                  sx={{
                    width: { sm: "321px", md: "413px" },
                  }}
                  height="467px"
                />
              </Container>
              <YearSelect disabled={yearDisabled} />
            </Container>

            <Container
              sx={{
                display: "flex",
                marginTop: "16px",
                justifyContent: "flex-end",
              }}
              disableGutters={true}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                onClick={(_) => setMoreOptions(!moreOptions)}
              >
                <Typography
                  color="primary.main"
                  fontWeight="500"
                  fontSize="14px"
                >
                  Show {moreOptions ? "less" : "more"} options
                </Typography>
                {!moreOptions ? (
                  <KeyboardArrowDownIcon
                    sx={{ color: "primary.main", marginLeft: "2px" }}
                  />
                ) : (
                  <KeyboardArrowUpIcon
                    sx={{ color: "primary.main", marginLeft: "2px" }}
                  />
                )}
              </Box>
            </Container>
          </Box>
          <Box sx={{ display: tabValue === 1 ? "block" : "none" }}></Box>
          <Box sx={{ display: tabValue === 2 ? "block" : "none" }}></Box>
        </Box>
      )}
      <SearchHomeModal open={searchModal} toggleDrawer={toggleSearchModal} />
    </Paper>
  );
}

export default Hero;
